import { styled } from 'styled-components';
import { classic } from '~/themes/classic';

//import iconTrophee from '@assets/images/icon/icon-trophee-gold.png'
import iconTrophee from '@assets/images/icon/trophee.png';

type IProps = {
  wonBattles: number;
};

type TProps = IProps;

export function WonBattleItem({ wonBattles }: TProps) {
  return (
    <Wrapper>
      <Container>
        <SImgTrophee src={iconTrophee} alt="" />
        <SSpan>{wonBattles}</SSpan>
      </Container>
    </Wrapper>
  );
}

const SSpan = styled.span<{ $isTimeOut?: boolean }>`
  color: ${classic.token?.colorWhite};
  font-family: 'Riffic Free', sans-serif;
  font-weight: 700;
  font-size: 1.5rem;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(65, 65, 65, 0.4);
  position: absolute;
  right: -9%;
  top: 50%;
  transform: translateY(-50%);

  @media screen and (max-height: 800px) {
    font-size: 1.35rem;
  }

  @media screen and (max-height: 450px) {
    font-size: 1.2rem;
  }

  @media screen and (max-width: 450px) {
    font-size: 1.2rem;
  }
`;

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  background-color: #fff;
  border-radius: 50%;
  height: 49px;
  width: 49px;
`;

const Container = styled.div<{ disabled?: boolean }>`
  background-image: linear-gradient(180deg, #ffdfd1 0%, #ea7a49 74%);
  border-radius: 50%;
  stroke-width: 1px;
  stroke: rgba(65, 65, 65, 0.3);
  box-shadow: 0px -3px 0px 0px rgba(0, 0, 0, 0.15) inset;
  height: 44px;
  width: 44px;
  position: relative;
  user-select: none;
  border: 1px solid rgba(65, 65, 65, 0.4);
`;

const SImgTrophee = styled.img`
  position: absolute;
  object-fit: contain;
  top: 50%;
  left: -15%;
  height: 90%;
  width: 90%;
  transform: translateY(-50%) rotate(-20deg);
`;
